import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

type MainContentProps = {
  children: ReactNode;
  disableSidebarOffset?: boolean;
  [x: string]: any;
};

const MainContent: React.FC<MainContentProps> = ({ children, disableSidebarOffset = false, ...rest }) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        ml: disableSidebarOffset ? { lg: 0 } : { lg: '280px' },
        width: disableSidebarOffset ? '100%' : { xs: '100%', lg: `calc(100% - 280px)` },
        flexDirection: 'column',
        position: 'relative',
        transition: 'all 0.5s ease',
      }}
      className="mainContent"
      {...rest}
    >
      {children}
    </Box>
  );
};

export default MainContent;
